import React, { Component } from 'react'
import ProfilePicture from 'components/profile/profile-picture'
//import TimeAgo from 'react-timeago'
import TimeAgo from 'timeago-react'
import moment from 'moment'

import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { 
	getCurrentAccount,
	getNotificationList
} from 'state/selectors'

import LoadMore from 'components/load-more/load-more'

import { 
	seeNotifications, 
	setNotificationOpenStatus, 
	clearNotifications,
	refreshUserData
} from 'state/actions'

import AlertBanner from 'components/alerts/alert-banner'

import { getNotificationUrl, formatByTimeZone } from 'utils'

class Notifications extends Component {
	state = {
		maxVisibleItems: 10
	}

	componentDidMount(){
		const {
			handleTouchMove
		} = this.props

		this.element = document.getElementById("notifications-list")

		this.element.addEventListener('touchmove', e => {
			handleTouchMove(e, 'move')
		}, {
			passive: false
		})

		this.element.addEventListener('touchstart', e => {
			handleTouchMove(e, 'start')
		}, {
			passive: false
		})
	}

	componentWillUnmount(){
		const {
			handleTouchMove,
			seeNotifications
		} = this.props

		this.element.removeEventListener('touchmove', e => {
			handleTouchMove(e, 'move')
		})

		this.element.removeEventListener('touchstart', e => {
			handleTouchMove(e, 'start')
		})

		seeNotifications()
	}

	openNotification = notification => {
		const {
			setNotificationOpenStatus,
			allEntities,
			currentAccount,
			history,
			closeCallback
		} = this.props

		setNotificationOpenStatus(notification.object)

		const newURL = getNotificationUrl(allEntities, notification.object, currentAccount)

		history.push(newURL)
		closeCallback()
	}

	loadMore = _ => {
		const {
			maxVisibleItems
		} = this.state

		this.setState({
			maxVisibleItems: (maxVisibleItems + 10)
		})
	}

	render() {
		const {
			maxVisibleItems
		} = this.state

		const {
			notificationsList,
			userData,
			object,
			clearNotifications,
			handleScroll
		} = this.props

		const {
			shouldShowAccounts,
			notifications
		} = notificationsList

		const slicedNotifications = notifications.slice(0, maxVisibleItems)

		return (
			<div>
				<h3 className="no-border">
					{ object.name }
					<div className="header-tab-controls">
						{
							slicedNotifications.length ?
							<button className={'active header-button'} onClick={_ => {clearNotifications(userData.notifications)}}>
								<span>
									Clear all
								</span>
							</button>
							: null
						}
					</div>
				</h3>
				<div 
					className="header-tab headertab-list-container" 
					ref="listContainer" 
					onScroll={e => { 
						handleScroll(this.refs.listContainer.scrollTop, e) 
					}}
					id="notifications-list"
				>
					{
						slicedNotifications.length ?
						<ul className="headertab-list">
							{
								slicedNotifications.map(notification => {
									let instigator = notification.instigator ? notification.instigator : null

									// We can just fake it, if we don't have the instigator in state.
									if(!instigator && notification.instigator_name){
										instigator = {
											image_tiny_thumb_url: notification.instigator_image_url,
											image_thumb_url: notification.instigator_image_url,
											image_url: notification.instigator_image_url
										}
									}

									return (
										<li 
											className={!notification.object.has_opened ? 'unseen list-item' : 'seen list-item'} 
											onClick={_ => { 
												notification.canOpen && this.openNotification(notification)
											}}
											key={notification.object.id}
										>
											{
												!notification.object.has_seen &&
												<i className="alert-dot"></i>
											}
											<ProfilePicture 
												user={instigator} 
												isFromHassl={!instigator}
												isTiny={true} 
											/>
											<div className="list-item-content">
												<div className="title" dangerouslySetInnerHTML={{ __html: notification.text }} />
												<span className="meta">
													<TimeAgo datetime={formatByTimeZone(notification.object.created_at, 'YYYY-MM-DD HH:mm:ss')} />
													{ (shouldShowAccounts && notification.account) ? 
														' • '+notification.account.name 
														: null
													}
												</span>
											</div>
										</li>
									);
								})
							}
							<LoadMore
								isLoading={false}
								canLoadMore={notifications.length > slicedNotifications.length}
								onClick={this.loadMore}
								type="notifications"
							/>
						</ul>
						:
						<AlertBanner 
							title={"Nothing to report, "+userData.first_name+"!"} 
							body="Get in there and make things happen." 
						/>
					}
				</div>
			</div>
		)
	}
}

function mapStateToProps(state, ownProps){
  return {
	allEntities: state.account.entities,
	notificationsList: getNotificationList(state, ownProps),
	currentAccount: getCurrentAccount(state),
  };
}

export default withRouter(connect(mapStateToProps, { 
	seeNotifications, 
	setNotificationOpenStatus, 
	clearNotifications, 
	getNotificationUrl,
	refreshUserData
})(Notifications))



// WEBPACK FOOTER //
// ./src/layout/header/header-tabs/notifications.jsx